export {
  SafeAreaProvider,
  SafeAreaView,
  initialWindowMetrics
} from "react-native-safe-area-context";
